"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Icon_base_1 = require("./Icon.base");
var Icon_styles_1 = require("./Icon.styles");
/**
 * Icons are used for rendering an individual's avatar, presence and details.
 * They are used within the PeoplePicker components.
 */
exports.Icon = Utilities_1.styled(Icon_base_1.IconBase, Icon_styles_1.getStyles, undefined, {
    scope: 'Icon'
}, true);
//# sourceMappingURL=Icon.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Icon/Icon.js
// module id = 645
// module chunks = 0